import { render } from "./AboutApp.vue?vue&type=template&id=1ae8a484&scoped=true"
import script from "./AboutApp.vue?vue&type=script&lang=js"
export * from "./AboutApp.vue?vue&type=script&lang=js"

import "./AboutApp.vue?vue&type=style&index=0&id=1ae8a484&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ae8a484"]])

export default __exports__